const s = "https://storage.googleapis.com/jolt.everon.io/icons.svg", o = "#3D2C4F", n = {
  running: {
    TEXT: "running",
    ICON: "icon-spinner"
  },
  successful: {
    TEXT: "successful",
    ICON: "icon-success"
  },
  error: {
    TEXT: "error",
    ICON: ""
  }
}, c = {
  SPACING: ["xs", "s", "m", "l", "xl", "xxl", "3xl"]
};
export {
  o as B,
  c as C,
  s as E,
  n as V
};
